import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import '../css/PrivacyPolicy.css';

const contentByLang = {
  it: {
    title: 'Informativa Privacy (GDPR)',
    updatedAt: 'Ultimo aggiornamento: 14 aprile 2026',
    intro:
      'Questa informativa descrive il trattamento dei dati personali effettuato tramite la piattaforma B2B GOOOLED in conformità al Regolamento UE 2016/679 (GDPR).',
    sections: [
      {
        heading: '1. Titolare del trattamento',
        body: [
          'GOOOLED srl',
          'Email: info@goooled.com',
        ],
      },
      {
        heading: '2. Dati trattati',
        body: [
          'Dati account: nome, email, ruolo, azienda, lingua preferita.',
          'Dati operativi: ordini, preventivi, carrello, note tecniche e commerciali.',
          'Dati tecnici: log di accesso e informazioni necessarie alla sicurezza del servizio.',
        ],
      },
      {
        heading: '3. Finalità e base giuridica',
        body: [
          'Erogazione del servizio B2B e gestione ordini/preventivi (esecuzione contrattuale).',
          'Gestione amministrativa e assistenza clienti (legittimo interesse / obblighi di legge).',
          'Sicurezza informatica, prevenzione abusi e tracciamento tecnico (legittimo interesse).',
        ],
      },
      {
        heading: '4. Conservazione dei dati',
        body: [
          'I dati sono conservati per il tempo necessario alla gestione del rapporto commerciale e agli obblighi normativi.',
          'I tempi di conservazione possono variare in base alla tipologia del dato e agli adempimenti legali applicabili.',
        ],
      },
      {
        heading: '5. Comunicazione e trasferimento dati',
        body: [
          'I dati possono essere trattati da fornitori tecnici incaricati (hosting, infrastruttura, servizi IT) come responsabili del trattamento.',
          "Non è prevista diffusione pubblica dei dati personali.",
        ],
      },
      {
        heading: '6. Diritti dell’interessato',
        body: [
          'Puoi richiedere accesso, rettifica, cancellazione, limitazione, opposizione e portabilità dei dati, nei limiti previsti dal GDPR.',
          'Puoi inoltre proporre reclamo all’autorità di controllo competente.',
        ],
      },
      {
        heading: '7. Contatti privacy',
        body: [
          'Per richieste privacy: info@goooled.com',
        ],
      },
    ],
    backToLogin: 'Torna al Login',
    legalNote:
      'Nota: questo testo è una base informativa operativa e può richiedere revisione legale formale prima della pubblicazione definitiva.',
  },
  en: {
    title: 'Privacy Notice (GDPR)',
    updatedAt: 'Last update: April 14, 2026',
    intro:
      'This notice describes how personal data is processed through the GOOOLED B2B platform in compliance with EU Regulation 2016/679 (GDPR).',
    sections: [
      {
        heading: '1. Data controller',
        body: [
          'GOOOLED srl',
          'Email: info@goooled.com',
        ],
      },
      {
        heading: '2. Data processed',
        body: [
          'Account data: name, email, role, company, preferred language.',
          'Operational data: orders, quotations, cart, technical and commercial notes.',
          'Technical data: access logs and information required for service security.',
        ],
      },
      {
        heading: '3. Purposes and legal basis',
        body: [
          'Providing the B2B service and managing orders/quotations (contract performance).',
          'Administrative handling and customer support (legitimate interest / legal obligations).',
          'IT security, abuse prevention and technical traceability (legitimate interest).',
        ],
      },
      {
        heading: '4. Data retention',
        body: [
          'Data is retained for as long as needed to manage the business relationship and legal obligations.',
          'Retention periods may vary based on data type and applicable legal requirements.',
        ],
      },
      {
        heading: '5. Data sharing and transfers',
        body: [
          'Data may be processed by appointed technical providers (hosting, infrastructure, IT services) acting as processors.',
          'Public disclosure of personal data is not intended.',
        ],
      },
      {
        heading: '6. Data subject rights',
        body: [
          'You may request access, rectification, deletion, restriction, objection and portability, within GDPR limits.',
          'You may also lodge a complaint with the competent supervisory authority.',
        ],
      },
      {
        heading: '7. Privacy contact',
        body: [
          'For privacy requests: info@goooled.com',
        ],
      },
    ],
    backToLogin: 'Back to Login',
    legalNote:
      'Note: this text is an operational baseline and may require formal legal review before final publication.',
  },
  de: {
    title: 'Datenschutzhinweis (DSGVO)',
    updatedAt: 'Letzte Aktualisierung: 14. April 2026',
    intro:
      'Dieser Hinweis beschreibt die Verarbeitung personenbezogener Daten über die GOOOLED B2B-Plattform gemäß der EU-Verordnung 2016/679 (DSGVO).',
    sections: [
      {
        heading: '1. Verantwortlicher',
        body: [
          'GOOOLED srl',
          'Email: info@goooled.com',
        ],
      },
      {
        heading: '2. Verarbeitete Daten',
        body: [
          'Kontodaten: Name, E-Mail, Rolle, Unternehmen, bevorzugte Sprache.',
          'Betriebsdaten: Bestellungen, Angebote, Warenkorb, technische und kommerzielle Notizen.',
          'Technische Daten: Zugriffsprotokolle und für die Sicherheit des Dienstes erforderliche Informationen.',
        ],
      },
      {
        heading: '3. Zwecke und Rechtsgrundlage',
        body: [
          'Bereitstellung des B2B-Dienstes und Verwaltung von Bestellungen/Angeboten (Vertragserfüllung).',
          'Administrative Abwicklung und Kundensupport (berechtigtes Interesse / gesetzliche Pflichten).',
          'IT-Sicherheit, Missbrauchsprävention und technische Nachverfolgbarkeit (berechtigtes Interesse).',
        ],
      },
      {
        heading: '4. Speicherdauer',
        body: [
          'Daten werden so lange gespeichert, wie es für die Geschäftsbeziehung und gesetzliche Pflichten erforderlich ist.',
          'Aufbewahrungsfristen können je nach Datentyp und anwendbaren gesetzlichen Anforderungen variieren.',
        ],
      },
      {
        heading: '5. Datenweitergabe und Übermittlungen',
        body: [
          'Daten können von beauftragten technischen Dienstleistern (Hosting, Infrastruktur, IT-Services) als Auftragsverarbeitern verarbeitet werden.',
          'Eine öffentliche Offenlegung personenbezogener Daten ist nicht vorgesehen.',
        ],
      },
      {
        heading: '6. Rechte der betroffenen Person',
        body: [
          'Sie können Auskunft, Berichtigung, Löschung, Einschränkung, Widerspruch und Übertragbarkeit im Rahmen der DSGVO verlangen.',
          'Sie können außerdem Beschwerde bei der zuständigen Aufsichtsbehörde einreichen.',
        ],
      },
      {
        heading: '7. Datenschutzkontakt',
        body: [
          'Für Datenschutzanfragen: info@goooled.com',
        ],
      },
    ],
    backToLogin: 'Zurück zum Login',
    legalNote:
      'Hinweis: Dieser Text ist eine operative Grundlage und kann vor der endgültigen Veröffentlichung eine formale rechtliche Prüfung erfordern.',
  },
};

const PrivacyPolicy = () => {
  const { lang } = useLanguage();
  const content = contentByLang[lang] || contentByLang.en;

  return (
    <div className="privacy-page">
      <div className="privacy-card">
        <h1>{content.title}</h1>
        <p className="privacy-updated">{content.updatedAt}</p>
        <p className="privacy-intro">{content.intro}</p>

        {content.sections.map((section) => (
          <section key={section.heading} className="privacy-section">
            <h2>{section.heading}</h2>
            {section.body.map((line) => (
              <p key={line}>{line}</p>
            ))}
          </section>
        ))}

        <p className="privacy-note">{content.legalNote}</p>

        <div className="privacy-actions">
          <Link to="/login">{content.backToLogin}</Link>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
